import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { clmApiClient } from '../clients';
import type { DepartmentDetails, DepartmentRequest } from '../types';

const fetchDepartmentDetails = async (
  data: DepartmentRequest,
): Promise<DepartmentDetails> => {
  if (data.departmentId == null) {
    return Promise.reject(new Error('departmentId is required'));
  }

  const response = await clmApiClient.post(
    `department/${data.departmentId}`,
    data,
  );

  if (!response.ok) {
    throw new Error(`Error fetching department data: ${response.problem}`);
  }

  return response.data as DepartmentDetails;
};

export const useDepartmentDetails = (
  data: DepartmentRequest,
  config?: Omit<UseQueryOptions<DepartmentDetails>, 'queryKey' | 'queryFn'>,
) =>
  useQuery({
    queryKey: ['department-details', data],
    queryFn: () => fetchDepartmentDetails(data),
    staleTime: 1000 * 60 * 5, // 5 minutes
    enabled: data.departmentId != null,
    ...config,
  });
